<template lang="pug">
.list-search
  el-form.search-data(:model="searchData" inline label-width="85px")
    el-form-item(label="订单编号:")
      el-input.search-input(placeholder="请输入订单编号" v-model.trim="searchData.bizOrderId" size="small")


    el-form-item(label="采购客户:")
      el-autocomplete.search-input(placeholder="请输入采购客户" v-model="buyerOrgName" size="small"
        @select="handleOrgName" :fetch-suggestions="queryBuyerOrgName" @blur="buyerOrgBlur")
        template(slot-scope="{ item }")
          span {{item.orgName}}

    el-form-item(label="仓库:")
      el-autocomplete.search-input(placeholder="请输入仓库" v-model="warehouseName" size="small"
        @select="handleSelect" :fetch-suggestions="getWarehosesList" @blur="warehosesBlur")
        template(slot-scope="{ item }")
          span {{item.nameAbbr}}

  el-form.search-data(:model="searchData" inline label-width="85px" v-show="isHasMore")
    el-form-item(label="买家手机:")
      el-input.search-input(placeholder="请输入买家手机号" v-model.trim="searchData.buyerPhone" size="small")

    el-form-item.dis-inf(label="类目名：")
      el-select.mini(v-model="secondCategoryId" placeholder="二级类目名" size="small" @change="selectSecond")
        el-option(label="全部" value="")
        el-option(v-for="item, index in secondCategories" :key="index" :label="item.name" :value="item.id")
      el-select.mini.ml-4(v-model="categoryIds" placeholder="三级类目名" size="small" multiple @change="selectThirds")
        el-option(label="全部" :value="0")
        el-option(v-for="item, index in thirdCategories" :key="index" :label="item.name" :value="item.id")

    el-form-item(label="下单时间:")
      el-date-picker.search-input(type="daterange" :editable="false" start-placeholder="开始日期"
        v-model="searchDate" size="small" unlink-panels value-format="yyyy-MM-dd" end-placeholder="结束日期")

    el-form-item(label="商品标题:")
      el-input.search-input(placeholder="商品的品材规产" v-model.trim="searchData.itemTitle" size="small")

    el-form-item(label="地区：")
      el-select.mini(v-model="searchData.provinceCode" placeholder="选择省份" size="small" @change="getCities")
        el-option(label="全部" value="")
        el-option(v-for="item, index in provinces" :key="index" :label="item.provinceName" :value="item.provinceCode")
      el-select.mini.ml-4(v-model="searchData.cityCode" placeholder="选择城市" size="small")
        el-option(label="全部" value="")
        el-option(v-for="item, index in cities" :key="index" :label="item.cityName" :value="item.cityCode")

    el-form-item(label="商品供应商:")
      el-input.search-input(placeholder="请输入供应商名称" v-model.trim="searchData.supplierName" size="small")

  .opt-item(label=" ")
    el-button(type="primary" @click="onSearch" size="small")  查询
    el-button(@click="resetSearchData" size="small" type="primary" plain) 重置
    el-button(type="primary" plain @click="exportData" size="small")  批量导出
    .has-more(@click="isHasMore = !isHasMore")
      span {{isHasMore ? '收起' : '更多筛选'}}
      i.el-icon-caret-bottom(:class="{'to-top': isHasMore}")
</template>

<script>
import { FILE_ACCESS_PRIVATE } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'
import dateFormat from '@/common/utils/date'

export default {
  name: 'ListSearch',
  data() {
    return {
      searchData: this.initData(),
      categoryIds: [0],
      secondCategoryId: '',
      searchDate: '',
      warehouseName: '',
      secondCategories: [],
      thirdCategories: [],
      provinces: [],
      cities: [],
      buyerOrgName: '',
      isHasMore: false
    }
  },
  mounted() {
    this.getCategoryTree()
    this.getProvinces()
    this.onSearch()
  },
  methods: {
    /** 重置查询条件 */
    resetSearchData() {
      this.searchData = this.initData()
      this.secondCategoryId = ''
      this.cities = []
      this.categoryIds = [0]
      this.thirdCategories = []
      this.warehouseName = ''
      this.warehouseNameCoyp = ''
      this.buyerOrgNameCoyp = ''
      this.buyerOrgName = ''
      this.searchDate = ''
      this.onSearch()
    },
    //  初始化数据
    initData(data = {}) {
      const {
        itemTitle = '',
        bizOrderId = '',
        buyerPhone = '',
        orgId = '',
        buyOrgId = '',
        warehouseId = '',
        cityCode = '',
        supplierName = '',
        provinceCode = ''
      } = data
      return {
        itemTitle,
        bizOrderId,
        buyerPhone,
        buyOrgId,
        orgId,
        warehouseId,
        cityCode,
        supplierName,
        provinceCode
      }
    },
    // 格式化数据
    formatData() {
      const startDate = (this.searchDate && this.searchDate[0]) || ''
      let endDate = (this.searchDate && this.searchDate[1]) || ''
      if (endDate) {
        endDate = dateFormat(+new Date(endDate) + 60 * 60 * 24 * 1000, 'yyyy-MM-dd')
      }
      this.searchData.categoryId = []
      if (this.secondCategoryId) {
        if (this.categoryIds.indexOf(0) > -1) {
          this.searchData.categoryId = []
          this.thirdCategories.forEach(item => {
            this.searchData.categoryId.push(item.id)
          })
        } else {
          this.searchData.categoryId = this.categoryIds
        }
      }
      this.searchData = Object.assign(this.searchData, {
        endDate,
        startDate
      })
    },
    /** 获取商品列表 */
    onSearch() {
      this.formatData()
      this.$emit('onSearch', this.searchData)
    },
    /** 导出订单列表 */
    async exportData() {
      this.formatData()
      this.$emit('onExport', this.searchData)
    },

    /** 选择仓库 */
    handleSelect(item) {
      if (item.id) {
        this.warehouseName = item.nameAbbr
        this.warehouseNameCoyp = item.nameAbbr
        this.searchData.warehouseId = item.id
      }
    },
    /** 选择采购客户 */
    handleOrgName(item) {
      if (item.orgId) {
        this.buyerOrgName = item.orgName
        this.buyerOrgNameCoyp = item.orgName
        this.searchData.buyOrgId = item.orgId
      }
    },
    /** 查询仓库失去焦点 */
    warehosesBlur() {
      if (!this.searchData.warehouseId || !this.warehouseName) {
        this.warehouseName = ''
        this.warehouseNameCoyp = ''
        this.searchData.warehouseId = ''
      }
    },
    /** 查询仓库失去焦点 */
    buyerOrgBlur() {
      if (!this.buyerOrgName || !this.searchData.buyOrgId) {
        this.buyerOrgName = ''
        this.buyerOrgNameCoyp = ''
        this.searchData.buyOrgId = ''
      }
    },
    /** 仓库模糊查询 */
    async getWarehosesList(name, cb) {
      let searchList = []
      if (name) {
        if (this.warehouseNameCoyp !== name) {
          this.searchData.warehouseId = ''
        }
        try {
          const result = await this.$post(
            'wh.pageQueryWarehoses',
            {
              warehoseQuery: {
                name,
                pageNo: 1,
                pageSize: 1000
              }
            },
            { notNeedLoading: true }
          )
          if (result.success && result.data[0]) {
            searchList = result.data[0].warehoses || [{ nameAbbr: '暂无数据' }]
          } else {
            searchList = [{ nameAbbr: '暂无数据' }]
          }
          cb(searchList)
        } catch (err) {
          console.log(err)
        }
      } else {
        cb([{ nameAbbr: '暂无数据' }])
      }
    },
    /** 查询采购客户名称  */
    async queryBuyerOrgName(orgName, cb) {
      let searchList = []
      if (orgName) {
        if (this.buyerOrgNameCoyp !== name) {
          this.searchData.buyOrgId = ''
        }
        try {
          const result = await this.$post(
            'trademanager.queryBuyerOrgNameForSeller',
            {
              orgName
            },
            { notNeedLoading: true }
          )
          if (result.success && result.data[0]) {
            searchList = result.data[0].orderOrgNameInfos || [{ orgName: '暂无数据' }]
          } else {
            searchList = [{ orgName: '暂无数据' }]
          }
          cb(searchList)
        } catch (err) {
          console.log(err)
        }
      } else {
        cb([{ orgName: '暂无数据' }])
      }
    },
    /** 获取类目列表*/
    async getCategoryTree() {
      try {
        const result = await this.$post('items.getCategoryTree')
        if (result.success) {
          if (result.data[0]) {
            this.secondCategories = result.data[0].children
          } else {
            this.$message.error('获取商品类目失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取省 */
    async getProvinces() {
      try {
        const result = await this.$post('user.getProvinces', {
          provinceCode: ''
        })
        if (result.success) {
          this.provinces = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取市 */
    async getCities() {
      this.searchData.cityCode = ''
      try {
        const result = await this.$post('user.getCities', {
          fatherCode: this.searchData.provinceCode
        })
        if (result.success) {
          this.cities = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 修改二级类目 获取三级类目 */
    selectSecond() {
      if (!this.secondCategoryId) {
        this.thirdCategories = []
      } else {
        this.secondCategories.forEach(item => {
          if (this.secondCategoryId === item.id) {
            this.thirdCategories = item.children
          }
        })
      }
      this.categoryIds = [0]
    },
    /** 选择三级类目 */
    selectThirds() {
      let len = this.categoryIds.length
      if (this.categoryIds[len - 1] === 0) {
        this.categoryIds = [0]
      } else {
        let allIndex = this.categoryIds.indexOf(0)
        if (allIndex > -1) {
          this.categoryIds.splice(allIndex, 1)
        }
      }
      if (this.categoryIds.length === this.thirdCategories.length) {
        this.categoryIds = [0]
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.list-search
  margin-bottom 20px
  /deep/.el-form-item
    margin-bottom 3px

  .mini
    width 120px
  .ml-4
    margin-left 4px

  .to
    display inline-block
    margin 0 10px
    color #999

  .search-input
    width 244px
  /deep/.el-form-item__label
    font-size 13px
    font-weight 400
  .w-200
    width 200px

  /deep/.el-date-editor.el-input
    width 165px
  .dis-inf
    /deep/.el-form-item__content
      display inline-flex
.opt-item
  padding-left 85px
  display flex
  align-items center
  .has-more
    font-size 12px
    margin-left 10px
    color #333
    cursor pointer
    &:hover
      color #efb96f
    i
      transition transform .3s
  .to-top
    transform rotate(180deg)
</style>
